@if (userProfile) {
    <div class="profil-container">
        <div class="page-top-banner">
            <div class="title">{{ 'Profile.Title' | translate }} "{{ userProfile.display ? userProfile.display : userProfile.id }}"</div>
        </div>
        <div class="content">
            <form [formGroup]="profileForm" (ngSubmit)="onSubmit()">
                <mat-tab-group>
                    <mat-tab label="{{ 'Profile.GeneralTab' | translate }}" formGroupName="generalGroup">
                        <mat-card class="box">
                            <mat-card-content>
                                @if (!isExternal) {
                                    <div>
                                        <mat-form-field>
                                            <mat-label>{{ 'Profile.OrganisationPlaceholder' | translate }}</mat-label>
                                            <input matInput formControlName="displayParentOrganization" readonly />
                                        </mat-form-field>
                                    </div>
                                }
                                <div>
                                    <mat-form-field>
                                        <mat-label>{{ 'Profile.InputDisplayPlaceholder' | translate }}</mat-label>
                                        <input matInput formControlName="display" readonly />
                                    </mat-form-field>
                                </div>
                                <div>
                                    <mat-form-field>
                                        <mat-label>{{ 'Profile.InputAccountPlaceholder' | translate }}</mat-label>
                                        <input matInput formControlName="account" readonly />
                                    </mat-form-field>
                                </div>
                                @if (!isExternal) {
                                    <div>
                                        <mat-form-field>
                                            <mat-label>{{ 'Profile.BillingPlaceholder' | translate }}</mat-label>
                                            <input matInput formControlName="billing" readonly />
                                        </mat-form-field>
                                    </div>
                                    <div>
                                        <mat-form-field>
                                            <mat-label>{{ 'Profile.InputNetworksPlaceholder' | translate }}</mat-label>
                                            <input matInput formControlName="networks" readonly />
                                            <mat-icon matSuffix matTooltip="{{ 'Profile.NetworksExplication' | translate }}">info</mat-icon>
                                        </mat-form-field>
                                    </div>
                                    <div>
                                        <mat-form-field>
                                            <mat-label>{{ 'Profile.CreatedDatePlaceholder' | translate }}</mat-label>
                                            <input matInput formControlName="createdAt" readonly />
                                        </mat-form-field>
                                    </div>
                                    <div>
                                        <mat-form-field>
                                            <mat-label>{{ 'Profile.UpdatedDatePlaceholder' | translate }}</mat-label>
                                            <input matInput formControlName="updatedAt" readonly />
                                        </mat-form-field>
                                    </div>

                                    <div>
                                        <mat-form-field>
                                            <mat-label>{{ 'Profile.OrganizationAccessLevel' | translate }}</mat-label>
                                            <input matInput formControlName="organizationAccessLevel" readonly />
                                        </mat-form-field>
                                    </div>
                                    <div>
                                        <mat-form-field>
                                            <mat-label>{{ 'Profile.UserAccessLevel' | translate }}</mat-label>
                                            <input matInput formControlName="userAccessLevel" readonly />
                                        </mat-form-field>
                                    </div>
                                    <div>
                                        <mat-form-field>
                                            <mat-label>{{ 'Profile.InputAppdataPlaceholder' | translate }}</mat-label>
                                            <textarea matInput formControlName="appData" readonly></textarea>
                                        </mat-form-field>
                                    </div>
                                }
                            </mat-card-content>
                        </mat-card>
                    </mat-tab>
                    <mat-tab label="{{ 'Profile.PropertiesTab' | translate }}">
                        <div>
                            <app-properties [properties]="userProperties" [isProfile]="true" [affinity]="affinity" (changed)="onPropertiesChanged($event)"></app-properties>
                        </div>
                    </mat-tab>
                    <mat-tab label="{{ 'Profile.RightsTab' | translate }}">
                        <div>
                            <app-rights [rights]="userRights" [affinity]="affinity" (changed)="onRightsChanged($event)" [readonly]="true"></app-rights>
                        </div>
                    </mat-tab>
                </mat-tab-group>
                <div class="buttons-band">
                    <button mat-stroked-button class="accent-button" type="button" (click)="cancelButtonClick()">{{ 'Profile.CancelButton' | translate }}</button>
                    <button mat-raised-button class="accent-button" [disabled]="" type="submit">{{ 'Profile.SubmitButton' | translate }}</button>
                </div>
            </form>
        </div>
    </div>
}
